/* eslint-disable @typescript-eslint/no-unused-vars-experimental */
import * as React from 'react';
import styled from 'styled-components';
import { Button, ButtonType } from '../../components/Button';
import { Text } from '../../components/Text';

const COOKIES_MODAL_HEIGHT = 96;

const ModalWrapper = styled.div<{ mounted: boolean }>`
  position: fixed;
  bottom: ${({ mounted }) => (mounted ? 0 : -COOKIES_MODAL_HEIGHT)}px;
  right: 0px;
  left: 0px;
  transition: all 1s;
  z-index: 9999;
`;

const CookiesModalComponent = styled.div`
  height: ${COOKIES_MODAL_HEIGHT}px;
  width: 100%;
  margin-top: auto;
  border-top: 1.5px solid #5a5b61;
  background: ${({ theme }) => (theme.isDark ? '#DCDCDC' : '#373B40')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 90px;
  ${({ theme }) => theme.mediaQueries.xLarge} {
    padding: 0px 40px;
  }
`;

const CookiesDescription = styled(Text)`
  display: inline;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  width: 100%;
  max-width: 500px;
  color: ${({ theme }) => theme.colors.font2};
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const DiscardButton = styled(Button)`
  background: transparent !important;
`;

const TermsHighlighted = styled.b`
  cursor: pointer;
`;

export interface ICookiesModalProps {
  onCookiesAccept: () => void;
  onDismiss?: () => void;
  delayInSeconds?: number;
  onTermsClicked?: () => void;
}

const CookiesModal: React.FunctionComponent<ICookiesModalProps> = props => {
  const {
    onCookiesAccept,
    onDismiss = () => null,
    delayInSeconds,
    onTermsClicked
  } = props;
  const [cookieModalMounted, setCookieModalMounted] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setCookieModalMounted(true);
    }, delayInSeconds || 2000);
  }, []);

  return (
    <ModalWrapper mounted={cookieModalMounted}>
      <CookiesModalComponent>
        <CookiesDescription>
          We use cookies to ensure that you get the best experience on your home
          owner panel. For more information see{' '}
          <TermsHighlighted onClick={() => onTermsClicked()}>
            Terms & Policy
          </TermsHighlighted>
        </CookiesDescription>
        <ButtonsWrapper>
          <DiscardButton
            text="DO NOT ALLOW"
            type={ButtonType.BUTTON}
            onClick={() => onDismiss()}
          />
          <Button
            text="ACCEPT & CLOSE"
            type={ButtonType.BUTTON}
            onClick={() => {
              onCookiesAccept();
              onDismiss();
            }}
          />
        </ButtonsWrapper>
      </CookiesModalComponent>
    </ModalWrapper>
  );
};

export default CookiesModal;
